import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['eventType', 'minTotalTimeOnEventInput', 'maxTotalTimeOnEventInput', 'coefficientModifierInput', 'enableImpressionsInput', 'enablePassersbyInput', 'enableIndirectlyEngagedStatisticsInput']
  static values = {
    config: Object
  }

  declare readonly eventTypeTarget: HTMLSelectElement
  declare readonly minTotalTimeOnEventInputTarget: HTMLInputElement
  declare readonly maxTotalTimeOnEventInputTarget: HTMLInputElement
  declare readonly coefficientModifierInputTarget: HTMLInputElement
  declare readonly enableImpressionsInputTarget: HTMLInputElement
  declare readonly enablePassersbyInputTarget: HTMLInputElement
  declare readonly enableIndirectlyEngagedStatisticsInputTarget: HTMLInputElement
  declare readonly hasCoefficientModifierInputTarget: boolean
  declare readonly configValue: Record<string, {
    min: number
    max: number
    impressions: boolean
    enable_passersby: boolean
    enable_indirectly_engaged_statistics: boolean
    coef: number
  }>

  updateFields (): void {
    const selected = this.eventTypeTarget.value
    const settings = this.configValue[selected]
    if (settings != null) {
      this.minTotalTimeOnEventInputTarget.value = settings.min.toString()
      this.maxTotalTimeOnEventInputTarget.value = settings.max.toString()
      this.enableImpressionsInputTarget.checked = settings.impressions
      this.enablePassersbyInputTarget.checked = settings.enable_passersby
      this.enableIndirectlyEngagedStatisticsInputTarget.checked = settings.enable_indirectly_engaged_statistics
      if (this.hasCoefficientModifierInputTarget) {
        this.coefficientModifierInputTarget.value = settings.coef.toString()
      }
    }
  }
}
